export default function LocationPinIcon() {
  return (
    <>
      <path
        d='M8.00188 9.45297C9.15063 9.45297 10.0819 8.52172 10.0819 7.37297C10.0819 6.22422 9.15063 5.29297 8.00188 5.29297C6.85312 5.29297 5.92188 6.22422 5.92188 7.37297C5.92188 8.52172 6.85312 9.45297 8.00188 9.45297Z'
        strokeWidth='1.47473'
      />
      <path
        d='M2.41184 6.16065C3.72517 0.387319 12.2785 0.393986 13.5852 6.16732C14.3518 9.55399 12.2452 12.4207 10.3985 14.194C9.0585 15.4873 6.9385 15.4873 5.59184 14.194C3.75184 12.4207 1.64517 9.54732 2.41184 6.16065Z'
        strokeWidth='1.47473'
      />
    </>
  );
}
